export default __webpack_public_path__ + "static/media/protocol-4.3dc46027.png";